<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.createdAt="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>
      <template v-slot:item.patient.cellphone="{ item }">
        <a
          id="openwhatsapp"
          target="_blank"
          :href="`https://wa.me/${item['patient.cellphone']}`"
        >
          <v-icon color="green"> mdi-whatsapp </v-icon>
        </a>
      </template>
      <template v-slot:item.status="{ item }">
        {{ getStatusText(item.status) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="selectHomeAppointment(item)"
          ><v-icon small color="orange">fa-edit</v-icon></v-btn
        >
      </template>
      <template v-slot:item.AttendedByUser="{ item }">
        {{ item['AttendedByUser.firstName'] }}
        {{ item['AttendedByUser.lastName'] }}
      </template>
      <template v-slot:item.FinishedByUser="{ item }">
        {{ item['FinishedByUser.firstName'] }}
        {{ item['FinishedByUser.lastName'] }}
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
          @change="onItemsPerPageChange"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>
    <home-appointment-dialog
      :homeAppointment="homeAppointment"
      :edit="edit"
      :dialog="dialog"
      @dismiss="newItem"
    />
  </div>
</template>

<script>
import HomeAppointmentDialog from './HomeAppointmentDialog.vue'
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
const HomeAppointmentRepository = Repository.get('homeAppointments')
import { format } from 'date-fns'

const APPOINTMENT_STATUS = {
  pending: 'Pendiente',
  finished: 'Finalizada',
  attended: 'Atendida',
}

export default {
  components: {
    HomeAppointmentDialog,
  },
  name: 'HomeAppointmentList',
  props: ['search'],
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    headers: [
      {
        text: 'Fecha',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'createdAt',
      },
      {
        text: 'Cédula',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patientId',
      },
      {
        text: 'Nombre',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient.firstName',
      },
      {
        text: 'Apellido',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient.lastName',
      },
      {
        text: 'Contacto',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient.cellphone',
      },
      {
        text: 'Estatus',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'status',
      },
      {
        text: 'Atendido por',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'AttendedByUser',
      },
      {
        text: 'Finalizado por',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'FinishedByUser',
      },
      {
        text: 'Opciones',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'actions',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
    edit: true,
    homeAppointment: null,
    dialog: false,
  }),
  methods: {
    newItem: function () {
      this.dialog = false
      this.loadData()
    },
    selectHomeAppointment: function (homeAppointment) {
      this.homeAppointment = Object.assign({}, homeAppointment)
      this.dialog = true
    },
    fetchPage: function (params) {
      return HomeAppointmentRepository.get(params)
    },
    getStatusText(status) {
      return APPOINTMENT_STATUS[status]
    },
    formatDate: (value) => {
      const date = value ? new Date(value) : new Date()
      return format(date, 'dd/MM/yyyy')
    },
  },
}
</script>
